// extracted by mini-css-extract-plugin
module.exports = {"stack":"ImagesStack_stack__3bdDp","stackImage":"ImagesStack_stackImage__3C_7u"};